import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Github, Linkedin, Mail, ArrowUpRight, Layout, Film, Phone, FileText, Video, MonitorPlay, Scissors } from 'lucide-react';
import './App.css';

const interactiveProjects = [
    {
      id: 2,
      title: "Pomodoro Timer",
      type: "Rive",
      link: "https://on.contra.com/kjQjqF",
      fullVideoUrl: "https://media.contra.com/video/upload/fl_progressive/w_1100/uyn5yqurqwthub78j075.mp4",
      isIframe: false,
      color: "var(--accent-teal)",
      gradient: "linear-gradient(135deg, #0d9488 0%, #2563eb 100%)"
    },
    {
      id: 3,
      title: "UI Element for Inhale/Exhale App",
      type: "Rive",
      link: "https://on.contra.com/DnGLjG",
      fullVideoUrl: "https://media.contra.com/video/upload/fl_progressive/w_1100/eua5ax9ausnrr5n3ljpx.mp4",
      isIframe: false,
      color: "var(--accent-indigo)",
      gradient: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
    },
    {
      id: 4,
      title: "Tamapet: A Tamagotchi Clone",
      type: "Rive",
      link: "https://on.contra.com/TGW8wp",
      fullVideoUrl: "https://media.contra.com/video/upload/fl_progressive/w_1100/xb9k2rfcqg5o4pop5mka.mp4",
      isIframe: false,
      color: "var(--accent-rose)",
      gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)"
    },
    {
      id: 20,
      title: "Canva Slides to Interactive Learning",
      type: "Rive",
      link: "https://contra.com/community/pC2LDvza-transform-static-canva-slides-into-interactive",
      fullVideoUrl: "https://media.contra.com/video/upload/fl_progressive/w_1200/aqaszysltv9vvnt2ipig.mp4",
      isIframe: false,
      color: "var(--accent-emerald)",
      gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)"
    }
  ];

  const animationProjects = [
    {
      id: 5,
      title: "Gru Rig Exercise",
      type: "3D Character Animation",
      link: "https://vimeo.com/1041783140",
      fullVideoUrl: "https://player.vimeo.com/video/1041783140?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-cyan)",
      gradient: "linear-gradient(135deg, #0891b2 0%, #0284c7 100%)"
    },
    {
      id: 6,
      title: "Synopme",
      type: "2D Character Animation",
      link: "https://vimeo.com/716099567",
      fullVideoUrl: "https://player.vimeo.com/video/716099567?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-fuchsia)",
      gradient: "linear-gradient(135deg, #c026d3 0%, #9333ea 100%)"
    },
    {
      id: 7,
      title: "Walk Cycle",
      type: "3D Character Animation",
      link: "https://vimeo.com/760817659",
      fullVideoUrl: "https://player.vimeo.com/video/760817659?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-indigo)",
      gradient: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
    },
    {
      id: 10,
      title: "Cutout Anime Style Sample",
      type: "2D Character Animation",
      link: "https://vimeo.com/765687525",
      fullVideoUrl: "https://player.vimeo.com/video/765687525?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-rose)",
      gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)"
    },
    {
      id: 11,
      title: "The Boy vs The Tree - Animatic",
      type: "Animatic",
      link: "https://vimeo.com/716626298",
      fullVideoUrl: "https://player.vimeo.com/video/716626298?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-slate)",
      gradient: "linear-gradient(135deg, #475569 0%, #1e293b 100%)"
    },
    {
      id: 12,
      title: "Café com Marketing",
      type: "2D Character Animation",
      link: "https://vimeo.com/515717620",
      fullVideoUrl: "https://player.vimeo.com/video/515717620?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-indigo)",
      gradient: "linear-gradient(135deg, #6366f1 0%, #4338ca 100%)"
    },
    {
      id: 13,
      title: "Jack Maverick",
      type: "2D Character Animation",
      link: "https://vimeo.com/458236209",
      fullVideoUrl: "https://player.vimeo.com/video/458236209?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-cyan)",
      gradient: "linear-gradient(135deg, #06b6d4 0%, #0369a1 100%)"
    },
    {
      id: 14,
      title: "Intro Aulas",
      type: "2D Character Animation",
      link: "https://vimeo.com/412165667",
      fullVideoUrl: "https://player.vimeo.com/video/412165667?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-teal)",
      gradient: "linear-gradient(135deg, #0d9488 0%, #0f766e 100%)"
    }
  ];

  const demoreelProjects = [
    {
      id: 19,
      title: "Demoreel 2026",
      type: "Demoreel",
      link: "https://vimeo.com/1195685549",
      fullVideoUrl: "https://player.vimeo.com/video/1195685549?autoplay=1&share=copy&fl=pl&fe=vl&h=493ae8f313",
      isIframe: true,
      color: "var(--accent-cyan)",
      gradient: "linear-gradient(135deg, #06b6d4 0%, #3b82f6 100%)"
    }
    /*
    {
      id: 9,
      title: "Demoreel 2025",
      type: "Demoreel",
      link: "https://vimeo.com/1157342989",
      fullVideoUrl: "https://player.vimeo.com/video/1157342989?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-amber)",
      gradient: "linear-gradient(135deg, #d97706 0%, #ea580c 100%)"
    },
    {
      id: 1,
      title: "Demoreel 2022",
      type: "Demoreel",
      link: "https://vimeo.com/771691538",
      fullVideoUrl: "https://player.vimeo.com/video/771691538?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-teal)",
      gradient: "linear-gradient(135deg, #0d9488 0%, #0f766e 100%)"
    },
    {
      id: 15,
      title: "Demoreel 2020",
      type: "Demoreel",
      link: "https://vimeo.com/421297193",
      fullVideoUrl: "https://player.vimeo.com/video/421297193?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-fuchsia)",
      gradient: "linear-gradient(135deg, #c026d3 0%, #9333ea 100%)"
    },
    {
      id: 16,
      title: "Demoreel 2015",
      type: "Demoreel",
      link: "https://vimeo.com/156270909",
      fullVideoUrl: "https://player.vimeo.com/video/156270909?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-rose)",
      gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)"
    }
    */
  ];

  const motionProjects = [
    {
      id: 8,
      title: "Phones Motion",
      type: "3D Product Animation",
      link: "https://vimeo.com/752760026",
      fullVideoUrl: "https://player.vimeo.com/video/752760026?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-emerald)",
      gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)"
    },
    {
      id: 17,
      title: "Pleno Imob",
      type: "Motion Design",
      link: "https://vimeo.com/352820607",
      fullVideoUrl: "https://player.vimeo.com/video/352820607?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-indigo)",
      gradient: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)"
    },
    {
      id: 18,
      title: "Intro Senso Comuna",
      type: "Motion Design",
      link: "https://vimeo.com/352815942",
      fullVideoUrl: "https://player.vimeo.com/video/352815942?autoplay=1&share=copy&fl=pl&fe=vl",
      isIframe: true,
      color: "var(--accent-cyan)",
      gradient: "linear-gradient(135deg, #06b6d4 0%, #0369a1 100%)"
    }
  ];

  const categories = [
    {
      id: 'Demoreels',
      title: 'Demoreel 2026',
      icon: <MonitorPlay size={20} />,
      color: "var(--accent-fuchsia)",
      projects: demoreelProjects
    },
    {
      id: 'Interactive Motion Design',
      title: 'Interactive Motion Design',
      icon: <Layout size={20} />,
      color: "var(--accent-cyan)",
      projects: interactiveProjects
    },
    {
      id: 'Motion Design',
      title: 'Motion Design',
      icon: <Film size={20} />,
      color: "var(--accent-amber)",
      projects: motionProjects
    },
    {
      id: 'Animation',
      title: 'Animation',
      icon: <Video size={20} />,
      color: "var(--accent-rose)",
      projects: animationProjects
    },
    {
      id: 'Video Editing',
      title: 'Video Editing',
      icon: <Scissors size={20} />,
      color: "var(--accent-emerald)",
      projects: [
        { id: 122, title: "Renée Zellweger & Bridget Jones Cast", type: "Newsweek's Channel Interview", link: "https://youtu.be/EQh_zhEnyWA?t=5", fullVideoUrl: "https://www.youtube.com/embed/EQh_zhEnyWA?autoplay=1&start=5", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 123, title: "Pillars Of The Green Transition At COP29 Sizzle Reel", type: "Newsweek's Events", link: "https://youtu.be/ge8lQjQc0Wg", fullVideoUrl: "https://www.youtube.com/embed/ge8lQjQc0Wg?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 124, title: "Pillars Of The Green Transition: A Newsweek Conference", type: "Newsweek's Events", link: "https://youtu.be/e25Xgp1u9Wo", fullVideoUrl: "https://www.youtube.com/embed/e25Xgp1u9Wo?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 125, title: "The Future Of Plastics: Reducing Waste & Rethinking Materials", type: "Newsweek's Events", link: "https://youtu.be/5FShrMBw9CI", fullVideoUrl: "https://www.youtube.com/embed/5FShrMBw9CI?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 126, title: "AI: Climate Hero Or Climate Villain?", type: "Newsweek's Events", link: "https://youtu.be/H6JZydndHZ0", fullVideoUrl: "https://www.youtube.com/embed/H6JZydndHZ0?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 127, title: "Newsweek Horizons Event Promo: Is AI The Cure For Doctor Burnout?", type: "Newsweek's Events", link: "https://youtu.be/UpauSaKBhl0", fullVideoUrl: "https://www.youtube.com/embed/UpauSaKBhl0?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 117, title: "Bem Maior Atacado E Varejo", type: "Advertising", link: "https://youtu.be/uMPLvxnUTZE", fullVideoUrl: "https://www.youtube.com/embed/uMPLvxnUTZE?autoplay=1", isIframe: true, color: "var(--accent-indigo)", gradient: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)" },
        { id: 118, title: "A Exclusiva Variedades", type: "Advertising", link: "https://youtu.be/d2mh1mqN9mM", fullVideoUrl: "https://www.youtube.com/embed/d2mh1mqN9mM?autoplay=1", isIframe: true, color: "var(--accent-indigo)", gradient: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)" },
        { id: 119, title: "Oticas La Vie", type: "Advertising", link: "https://youtu.be/tdPxUx2ySrA", fullVideoUrl: "https://www.youtube.com/embed/tdPxUx2ySrA?autoplay=1", isIframe: true, color: "var(--accent-indigo)", gradient: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)" },
        { id: 120, title: "Absoluto - A Vida É Uma Competição", type: "Advertising", link: "https://youtu.be/uMqmnTLueQQ", fullVideoUrl: "https://www.youtube.com/embed/uMqmnTLueQQ?autoplay=1", isIframe: true, color: "var(--accent-indigo)", gradient: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)" },
        { id: 121, title: "Objetivo Gurupi", type: "Advertising", link: "https://youtu.be/wPCovRtx8Kc", fullVideoUrl: "https://www.youtube.com/embed/wPCovRtx8Kc?autoplay=1", isIframe: true, color: "var(--accent-indigo)", gradient: "linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)" },

        { id: 106, title: "Meteoro Da Ilusão", type: "Purosso's Channel", link: "https://youtu.be/qTHgVSc4ATU", fullVideoUrl: "https://www.youtube.com/embed/qTHgVSc4ATU?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 107, title: "Perguntas Idiotas Sobre Tatuagem", type: "Purosso's Channel", link: "https://youtu.be/7DfZcYxBvK0", fullVideoUrl: "https://www.youtube.com/embed/7DfZcYxBvK0?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 108, title: "Top 5 Jogos Da Minha Infância", type: "Purosso's Channel", link: "https://youtu.be/ljluZr8URZA", fullVideoUrl: "https://www.youtube.com/embed/ljluZr8URZA?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 109, title: "Seres Invisíveis", type: "Purosso's Channel", link: "https://youtu.be/OZPf4LayTTw", fullVideoUrl: "https://www.youtube.com/embed/OZPf4LayTTw?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 110, title: "Karaokê", type: "Purosso's Channel", link: "https://youtu.be/jzO5gY1aljE", fullVideoUrl: "https://www.youtube.com/embed/jzO5gY1aljE?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 111, title: "Minha Primeira Tattoo (Parte 2)", type: "Purosso's Channel", link: "https://youtu.be/nC6LB1NOP4k", fullVideoUrl: "https://www.youtube.com/embed/nC6LB1NOP4k?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 112, title: "Cigarro? Não, Obrigado!", type: "Purosso's Channel", link: "https://youtu.be/1VoZyU8LsVg", fullVideoUrl: "https://www.youtube.com/embed/1VoZyU8LsVg?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 113, title: "Mulheres Com Atitude", type: "Purosso's Channel", link: "https://youtu.be/a818QM9lE-M", fullVideoUrl: "https://www.youtube.com/embed/a818QM9lE-M?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 114, title: "Minha Primeira Tattoo (Parte 1)", type: "Purosso's Channel", link: "https://youtu.be/lLopoHCwa-A", fullVideoUrl: "https://www.youtube.com/embed/lLopoHCwa-A?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 115, title: "Resoluções Para 2017", type: "Purosso's Channel", link: "https://youtu.be/-ojTWgPjvX4", fullVideoUrl: "https://www.youtube.com/embed/-ojTWgPjvX4?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },
        { id: 116, title: "Último Vídeo (De 2016)", type: "Purosso's Channel", link: "https://youtu.be/c_KQHYn1DHk", fullVideoUrl: "https://www.youtube.com/embed/c_KQHYn1DHk?autoplay=1", isIframe: true, color: "var(--accent-rose)", gradient: "linear-gradient(135deg, #e11d48 0%, #db2777 100%)" },

        { id: 101, title: "Geração Livre Inverno 2017", type: "Fashion Film", link: "https://vimeo.com/209965262", fullVideoUrl: "https://player.vimeo.com/video/209965262?autoplay=1", isIframe: true, color: "var(--accent-emerald)", gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)" },
        { id: 102, title: "Mt Malhas Fashion Film Inverno Teaser", type: "Fashion Film", link: "https://vimeo.com/189140272", fullVideoUrl: "https://player.vimeo.com/video/189140272?autoplay=1", isIframe: true, color: "var(--accent-emerald)", gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)" },
        { id: 103, title: "Geração Livre - Alto Verão 2017", type: "Fashion Film", link: "https://vimeo.com/187183480", fullVideoUrl: "https://player.vimeo.com/video/187183480?autoplay=1", isIframe: true, color: "var(--accent-emerald)", gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)" },
        { id: 104, title: "Geração Livre Verão 2017", type: "Fashion Film", link: "https://vimeo.com/170076256", fullVideoUrl: "https://player.vimeo.com/video/170076256?autoplay=1", isIframe: true, color: "var(--accent-emerald)", gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)" },
        { id: 105, title: "Mt Malhas Fashion Film Inverno", type: "Fashion Film", link: "https://vimeo.com/189141769", fullVideoUrl: "https://player.vimeo.com/video/189141769?autoplay=1", isIframe: true, color: "var(--accent-emerald)", gradient: "linear-gradient(135deg, #059669 0%, #10b981 100%)" }
      ]
    }
  ];

function App() {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [cursorPos, setCursorPos] = useState({ x: 0, y: 0 });
  const [expandedCategory, setExpandedCategory] = useState(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      setCursorPos({ x: e.clientX, y: e.clientY });
    };
    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  return (
    <div className="app">
      <motion.div
        className="cursor-glow"
        animate={{ x: cursorPos.x - 200, y: cursorPos.y - 200 }}
        transition={{ type: "spring", damping: 30, stiffness: 200 }}
      />

      <div className="grain-overlay" />

      <div className="linktree-container">
        {/* Profile Header */}
        <motion.header
          className="profile-section"
          initial={{ y: 20, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
        >
          <img src="/profile.png" alt="Regis Pereira" className="profile-avatar" />
          <h1>Régis Pereira</h1>
          <p className="profile-bio">2D/3D Motion Designer & Animator<br />Interactive Motion Designer<br />Video Editor</p>

          <div className="social-links-row">
            <a href="https://www.linkedin.com/in/regisp/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
              <Linkedin size={22} />
            </a>
            <a href="https://github.com/pereiraregis/" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="GitHub">
              <Github size={22} />
            </a>
            <a href="mailto:pereiraregis@proton.me" className="social-icon" aria-label="Email">
              <Mail size={22} />
            </a>
            <a href="https://wa.me/5554991862354" target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="WhatsApp">
              <Phone size={22} />
            </a>
          </div>

          <a href="/REGIS PEREIRA - RESUME.pdf" target="_blank" rel="noopener noreferrer" className="resume-download-btn">
            <FileText size={18} />
            <span>Download Resume</span>
          </a>
        </motion.header>
        {/* Categories */}
        <main className={`links-section ${expandedCategory ? 'has-active' : 'none-active'}`}>
          {categories.map((category, catIndex) => {
            const isExpanded = expandedCategory === category.id;
            return (
              <motion.div
                key={category.id}
                className={`category-group ${isExpanded ? 'active' : 'collapsed'}`}
              >
                <div
                  className="category-title"
                  onClick={() => setExpandedCategory(isExpanded ? null : category.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="category-header-left">
                    <span className="category-icon" style={{ color: category.color }}>
                      {category.icon}
                    </span>
                    <h2>{category.title}</h2>
                  </div>
                  <motion.span
                    className="expand-indicator"
                    animate={{ rotate: isExpanded ? 180 : 0 }}
                  >
                    ▼
                  </motion.span>
                </div>

                <AnimatePresence mode="wait">
                  {isExpanded && (
                    <motion.div
                      className="links-list"
                      initial={{ opacity: 0, height: 0 }}
                      animate={{ opacity: 1, height: 'auto' }}
                      exit={{ opacity: 0, height: 0 }}
                      transition={{
                        opacity: { duration: 0.3 },
                        height: { duration: 0.4, ease: "easeInOut" }
                      }}
                    >
                      {category.projects.map((project, index) => (
                        <motion.div
                          key={project.id}
                          className="link-card"
                          initial={{ x: -10, opacity: 0 }}
                          animate={{ x: 0, opacity: 1 }}
                          transition={{ delay: 0.1 + index * 0.05 }}
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => setSelectedVideo(project)}
                        >
                          <div className="link-gradient-hover" style={{ background: project.gradient }} />
                          <div className="link-content">
                            <span className="link-title">{project.title}</span>
                            <div className="link-actions">
                              <span className="type-badge" style={{ color: project.color, borderColor: project.color }}>{project.type}</span>
                              <button className="icon-btn" onClick={(e) => { e.stopPropagation(); window.open(project.link, '_blank'); }} aria-label="Open Project Link">
                                <ArrowUpRight size={18} />
                              </button>
                            </div>
                          </div>
                        </motion.div>
                      ))}
                    </motion.div>
                  )}
                </AnimatePresence>
              </motion.div>
            );
          })}
        </main>
      </div>

      <AnimatePresence>
        {selectedVideo && (
          <motion.div
            className="video-modal-overlay"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedVideo(null)}
          >
            <motion.div
              className="video-modal-content"
              initial={{ scale: 0.9, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.9, opacity: 0 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-modal" onClick={() => setSelectedVideo(null)}>×</button>
              {selectedVideo.isIframe ? (
                <iframe
                  src={selectedVideo.fullVideoUrl}
                  frameBorder="0"
                  allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                  referrerPolicy="strict-origin-when-cross-origin"
                  allowFullScreen
                ></iframe>
              ) : (
                <video
                  src={selectedVideo.fullVideoUrl}
                  controls
                  autoPlay
                  playsInline
                  style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                />
              )}
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
